import { blobToText, downloadFile, downloadFileCustom } from "@/utils/tool";
import { debounce } from "lodash";
import { getAllTree, getDictPage } from "@/views/commonApi";
import { getPage as getRoleData } from "@/views/SystemManagement/RolePermissionManagement/api";
import { getSelectCompany } from "@/views/SystemManagement/CompanyManagement/api";
import { getBranchBaseList } from "@/views/SystemManagement/BranchManagement/api";

const mixin = {
  data() {
    return {
      downloadLoading: false,
      tableData: [],
      roleData: [],
      companyData: [],
      belongCompanyData: [],
      companyType: localStorage.getItem("companyType"),
      deptData: [],
      searchForm: {}, // 重置搜索参数
      tableOptions: {
        loading: false,
        currentPage: 1,
        pageCount: 0,
        pageSize: 10,
        total: 0
      },
      belongCompanyId: "",
      getTableMethod: "", // 表格api
      deleteMethod: "", // 删除api
      downloadFileMethod: "", // 导出api
      multipleSelection: [], // 选中的列表id数组
      isImmediatelyGetData: true, // 是否立即获取数据，默认是
      haveRole: false, // 是否需要角色数据
      haveDept: false, // 是否需要组织树
      haveCompany: false, // 是否需要公司
      haveBelongCompany: false // 是否需要分公司公司
    };
  },
  async mounted() {
    // 【重点】满足条件时，等待分公司接口完成，再继续后面逻辑
    if (this.companyType === "1" && this.haveBelongCompany) {
      await this.getSelectBelongCompany();
    }
    // 这些字典接口可以并行，不需要互相等待
    const promiseList = [];
    if (this.haveRole) promiseList.push(this.getRoleData());
    if (this.haveDept) promiseList.push(this.getDeptData());
    if (this.haveCompany) promiseList.push(this.getSelectCompany());
    await Promise.all(promiseList);

    if (this.isImmediatelyGetData) await this.getTableData();
  },
  methods: {
    getRoleData() {
      return getRoleData().then((res) => {
        if (res.code === 200) {
          this.roleData = res.data;
        }
      });
    },
    getDeptData() {
      return getAllTree().then((res) => {
        if (res.code === 200) {
          this.deptData = res.data;
        }
      });
    },
    getSelectCompany() {
      return getSelectCompany().then((res) => {
        if (res.code === 200) {
          this.companyData = res.data;
        }
      });
    },
    // 获取分公司列表【增加return Promise，让await生效】
    getSelectBelongCompany() {
      return getBranchBaseList().then((res) => {
        if (res.code === 200) {
          this.belongCompanyData = res.data;
          this.belongCompanyId = res.data[0].companyId;
          this.searchForm.belongCompanyId = res.data[0].companyId;
        }
      });
    },
    handleCheck() {
      this.handleOtherThing()
      this.getTableData();
    },
    // 重置
    // 重置
// keepFields: 需要保留不被重置的字段名数组，例如 this.handleReset(['belongCompanyId'])
    handleReset(keepFields) {
      // 1. 先把需要保留的字段值存起来
      const saved = {};
      if (Array.isArray(keepFields)) {
        keepFields.forEach((key) => {
          saved[key] = this.searchForm[key];
        });
      }
      // 2. 重置 searchForm
      this.searchForm = this.$options.data.call(this).searchForm;
      // 3. 把保留字段写回
      if (Array.isArray(keepFields)) {
        keepFields.forEach((key) => {
          this.searchForm[key] = saved[key];
        });
      }
      this.searchForm.belongCompanyId = this.belongCompanyId
      this.tableOptions.currentPage = 1;
      this.searchPage();
      this.handleOtherThing();
    },

    // handleReset() {
    //   this.searchForm = this.$options.data.call(this).searchForm;
    //   this.tableOptions.currentPage = 1;
    //   this.searchPage();
    //   this.handleOtherThing();
    // },
    handleEdit(row) {
      this.$refs.addOrEdit.init(row);
    },
    handleOtherThing() {},
    // 新增
    handleAdd() {
      this.$refs.addOrEdit.init();
    },
    handleChangeOtherThing() {
      if (this.$refs.customTable) {
        this.$refs.customTable.clearSelect()
      }
    },
    // 编辑或添加后列表操作
    handleAddOrEditSuccess(val, menuType) {
      this.handleChangeOtherThing()
      if (val === "add") {
        this.tableOptions.currentPage = 1;
        this.resetSearchForm(menuType);
      }
      this.getTableData();
      // console.log("detailInfo", val);
    },
    resetSearchForm(key) {
      let saveKeyValue = "";
      if (key) {
        saveKeyValue = this.searchForm[key];
      }
      this.searchForm = this.$options.data.call(this).searchForm;
      // // console.log("saveKeyValue", this.searchForm);
      if (key) {
        this.searchForm[key] = saveKeyValue;
      }
    },
    searchPage: debounce(function () {
      this.tableOptions.currentPage = 1;
      this.getTableData();
    }, 300),
    handleSizeChange(val) {
      this.tableOptions.currentPage = val.page;
      this.tableOptions.pageSize = val.size;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.tableOptions.currentPage = val;
      this.getTableData();
    },
    getTableData() {
      let params = {
        currentPage: this.tableOptions.currentPage,
        pageSize: this.tableOptions.pageSize,
        param: { ...this.searchForm }
      };
      // // console.log("传参----", params);
      this.tableOptions.loading = true;
      this.getTableMethod(params)
        .then((res) => {
          this.tableOptions.loading = false;
          if (res.code === 200) {
            if (this.tableOptions.currentPage > 1 && (res.data === undefined || res.data.data.length === 0)) {
              this.tableOptions.currentPage--;
              this.getTableData();
              return;
            }
            if (res.data.data && res.data.data.length > 0) {
              res.data.data.forEach((item) => {
                item.loading = false;
              });
            }
            // // console.log("返回结果----", res.data.data);
            this.tableData = res.data.data;
            this.tableOptions.total = res.data.totalCount;
            this.tableOptions.pageCount = res.data.totalPage;
          }
        })
        .catch(() => {
          this.tableOptions.loading = false;
        });
    },
    handleDelete(id, msg = "此操作将删除该数据, 是否继续?") {
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(() => {
        this.deleteMethod(id).then((res) => {
          if (res.code === 200) {
            this.handleOtherOperate();
            this.getTableData();
          }
        });
      });
    },
    handleOtherOperate() {},
    // 导出
    handleDownload(fileName) {
      //没有数据的时候禁止导出操作
      if (this.tableOptions.total <= 0) {
        this.$message.error("暂无数据导出！");
        return;
      }
      this.downloadLoading = true;
      this.downloadFileMethod(this.searchForm)
        .then((res) => {
          this.downloadLoading = false;
          blobToText(res.data).then((data) => {
            // // console.log("data", data);
            downloadFileCustom(data, fileName);
          });
        })
        .catch(() => {
          this.downloadLoading = false;
        });
    }
  }
};
export default mixin;
